var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-header',{on:{"show":_vm.handleChildEvent,"showstatus":_vm.showstatus}}),_c('app-main',{attrs:{"show":_vm.show,"status":_vm.status},on:{"show":_vm.handleChildEvent,"showstatus":_vm.showstatus}}),_c('router-view',{on:{"show":_vm.handleChildEvent,"showstatus":_vm.showstatus}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }